import DashboardLayout from '@/pages/Layout/DashboardLayout.vue'

import Dashboard from '@/pages/Dashboard.vue'


import Settings from '@/pages/Settings.vue'

import Scan from '@/pages/Scan.vue'

import Note from '@/pages/Note.vue'

import Logout from '@/pages/Logout.vue'





const routes = [
	{
		path: '/',
		component: DashboardLayout,
		redirect: '/dashboard',
		children: [
			{
				path: 'dashboard',
				name: 'ផ្ទាំងទាំងអស់',
				component: Dashboard
			},
			{
				path: 'settings',
				name: "ផ្លាស់ប្តូរពាក្យសំងាត់",
				component: Settings,
			},
			{
				path: 'note/:hash_id',
				name: "កំណត់ចំណាំ",
				component: Note,
			},
			{
				path: 'scan',
				name: "បង្កើតកញ្ចប់ឥវ៉ាន់ថ្មី",
				component: Scan,
			},
			{
				path: 'logout',
				name: "ចាកចេញ",
				component: Logout,
			}
		]
	}
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js